import { connect } from 'react-redux';
import Global from '../../store/global-selectors';
import { DateService } from '../../services/date-service';
import { UserTimeFormat as UserTimeFormatComponent } from './index';

const mapStateToProps = (state, { value }) => {
  const userTimeFormat = Global.selectUserUserTimeFormat(state);
  const timeZone = Global.selectSellerTimeZoneIANA(state);
  const dateValue = DateService.isDateInstance(value) ? value : DateService.convertToLocalDate(value);

  return {
    userTimeFormat,
    timeZone,
    value: dateValue,
  };
};

export const UserTimeFormat = connect(mapStateToProps)(UserTimeFormatComponent);
